import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../hooks/customDeviceDetect";
import Dropdown from "../../core/dropdown/Dropdown";
import Icon from "../../core/icon/Icon";
import Seperator from "../../core/seperator/Seperator";
import LanguageSettings from "../../molecules/languageSettings/LanguageSettings";
import { useModals } from "../../molecules/modalStack/ModalProvider";

const AvatarMenu = ({ items, variant, user, handle, project }) => {
  const { t, i18n } = useTranslation();
  const { openModal } = useModals();
  const isMobile = useIsMobile();

  const mergedItems = useMemo(() => {
    // Dynamic options based on user state
    const options =
      items ||
      [
        !user?.userId && {
          text: t("auth:profile.registerOrLogin"),
          leadingIcon: "user-fill",
          onClick: handle?.login,
          "data-cy": "register-openButton",
        },
        variant === "ideaMap" &&
          user?.userId && {
            text: t("auth:profile.showMyProfile"),
            leadingIcon: "user-fill",
            onClick: handle?.openMyAccount,
          },
        user?.userId && {
          text: t("auth:profile.edit"),
          leadingIcon: "edit",
          onClick: handle?.setAuthEditOpen,
        },
        user?.userId && {
          text: t("auth:logout"),
          leadingIcon: "logout",
          onClick: handle?.logout,
          "data-cy": "logout",
        },
        // {
        //   text: t("util:adjust", { val: t("global:language") }),
        //   leadingIcon: `locales/${i18n.resolvedLanguage}`,
        //   onClick: () =>
        //     openModal(<LanguageSettings project={project} />, {
        //       id: "languageModal",
        //       title: t("util:adjust", { val: t("global:language") }),
        //       swipe: !!isMobile,
        //       zIndex: 999,
        //     }),
        // },
        {
          children: (
            <>
              <Seperator />
              <div className="flex flex-col gap-2 px-5 py-2 pb-5">
                <DropdownMenu.Item
                  asChild
                  className="[&[data-highlighted]]:outline-black [&[data-hoverable]]:hover:bg-transparent [&[data-hoverable]]:hover:outline-none"
                  data-hoverable="false"
                >
                  <a
                    className="body-md text-text-subdued text-start hover:underline"
                    target="_blank"
                    href={`/projects/${project?.projectId}/imprint`}
                    rel="noreferrer"
                  >
                    {t("global:imprint")}
                  </a>
                </DropdownMenu.Item>
                <DropdownMenu.Item
                  asChild
                  className="[&[data-highlighted]]:outline-black [&[data-hoverable]]:hover:bg-transparent [&[data-hoverable]]:hover:outline-none"
                  data-hoverable="false"
                >
                  <a
                    className="body-md text-text-subdued text-start hover:underline"
                    target="_blank"
                    href={`/projects/${project?.projectId}/terms`}
                    rel="noreferrer"
                  >
                    {t("global:termsAndConditions")}
                  </a>
                </DropdownMenu.Item>
                <DropdownMenu.Item
                  asChild
                  className="[&[data-highlighted]]:outline-black [&[data-hoverable]]:hover:bg-transparent [&[data-hoverable]]:hover:outline-none"
                  data-hoverable="false"
                >
                  <a
                    className="body-md text-text-subdued text-start hover:underline"
                    target="_blank"
                    href={`/projects/${project?.projectId}/privacyPolicy`}
                    rel="noreferrer"
                  >
                    {t("global:dataProtection")}
                  </a>
                </DropdownMenu.Item>
                {/* <a
                  className="body-md text-text-subdued text-start hover:underline"
                  target="_blank"
                  href={`/projects/${project?.projectId}/accessibilityStatement`}
                  rel="noreferrer"
                >
                  {t("accessibilityStatement:title")}
                </a> */}
              </div>
            </>
          ),
        },

        // Additional dynamic options can be added here
      ].filter(Boolean);

    // Static options that are always present

    // Combine dynamic and static options
    return options;
  }, [user, t, handle, variant, i18n.resolvedLanguage, isMobile]);

  return (
    <nav aria-label={"menu"}>
      <Dropdown
        items={mergedItems}
        hasArrow={false}
        aria-label={"menu"}
        trailingIcon={false}
        closeOnClick={true}
        leadingIcon="hamburger"
        variant="outline"
        className="bg-white shadow-xl"
        size={isMobile ? "md" : "lg"}
      />
    </nav>
  );
};

export default AvatarMenu;
